// for compatibility in vue.config.js
module.exports = {
  title: "战疫求助平台",
  baseUrl: process.env.NODE_ENV === "production" ? "/a/ci22-covid19/" : process.env.BASE_URL,
}